module.exports = __webpack_public_path__ + "static/media/South Korea.53a342dc.png";